export const environment = {
  baseApiUrl: 'https://de-uhc-uat-b9a2hwh9dsdxa2b3.eastus2-01.azurewebsites.net/',
  redirectUrl: 'https://Dataexplorerplus-UHG-Dev.kantar.com/landing',
  kantarClientID: '66b6b78d-15ab-44e8-a7b2-be3339c33541',
  kantarApiClientID: 'acce1783-ddd4-46ec-b38e-95887f7bf975',
  kantarAuthorityID: 'https://login.microsoftonline.com/1e355c04-e0a4-42ed-8e2d-7351591f0ef1',
  UserGuideUrl: 'https://elearning.easygenerator.com/bcd568f0-29e3-43fb-a042-238bfbb04e6e/',
  UserGuideSnapshotUrl: 'https://elearning.easygenerator.com/4168a9e6-5f42-4a18-80cd-5aeab0add565/',
  logoutURL: 'https://Dataexplorerplus-UHG-Dev.kantar.com/signout-oidc',
  sessionTimeOut: '60',
  env: 'dev',
  showUploadModule: 'true',
  askMePythonUrl: 'https://askmepythonapi-atcphegjdudxbsav.northeurope-01.azurewebsites.net/',
  dedicatedCss: '',
};
